module.exports = __webpack_public_path__ + "img/img-cardnews-02-1.c2f4e2e4.png";